import type z from 'zod/v4'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

export const BookLevel = pgTable(
  'book_level',
  {
    id: uuid().notNull().primaryKey(),
    name: text().notNull(),
    description: text(),
    order: integer().notNull(),
    legacyLevelId: integer(),
    legacyNeonBookLevelId: uuid(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
  },
  (table) => [
    index('book_level_name_idx').on(table.name),
    index('book_level_order_idx').on(table.order),
    index('book_level_updated_at_idx').on(table.updatedAt),
    index('book_level_created_at_idx').on(table.createdAt),
    index('book_level_legacy_neon_book_level_id_idx').on(table.legacyNeonBookLevelId),
  ],
)

export const InsertBookLevelSchema = createInsertSchema(BookLevel)
export const UpdateBookLevelSchema = createUpdateSchema(BookLevel)
  .omit({ id: true, legacyLevelId: true, legacyNeonBookLevelId: true })
  .partial()
export const SelectBookLevelSchema = createSelectSchema(BookLevel)

export type InsertBookLevel = typeof BookLevel.$inferInsert
export type UpdateBookLevel = z.infer<typeof UpdateBookLevelSchema>
export type SelectBookLevel = typeof BookLevel.$inferSelect
